<template>
  <div
    v-if="render"
    class="mppay-wrap"
  >
    <section class="userinfo">
      <div :class="spriteCalss('user-bg', 'top-banner')">
        <dl>
          <dt>
            <img
              :src="userInfo.avatar || avatar"
              alt=""
              :class="spriteCalss('user-avatar', 'icon-avatar')"
              @dblclick="clearCookie"
            >
          </dt>
          <dd>
            <span class="nickname">{{ userInfo.nickname || '' }}</span>
            <span
              class="expire"
            > {{ expireText() }}</span>
          </dd>
        </dl>
        <dl>
          <dd>
            <span class="pdf-name">极光阅读</span>
            <span
              class="introduction"
            >实时修改标注PDF文档，让办公更加高效</span>
          </dd>
        </dl>
      </div>
    </section>

    <WeChatHomeTab
      :tabs="tabs"
      :cur-tab="curTab"
      @changeTab="clickTab"
    />

    <section
      v-if="!payModuleShow"
      class="package-container"
    >
      <div class="timeopts-overflow">
        <ul class="timeopts-ul">
          <li
            v-for="(i, idx) in settings"
            :key="idx"
            :class="{ active: isActive === idx }"
            class="timeopts-li"
            @click="clickPrice(idx, i.id, i)"
          >
            <div class="timeopts-litips">
              {{ i.description }}
            </div>
            <div class="timeopts-content">
              <p class="price">
                ￥{{ i.current_price }}
              </p>
              <p
                class="tip"
                :class="tipClass[i.bottom_type]"
              >
                {{ i.bottom }}
              </p>
            </div>
          </li>
        </ul>
      </div>
      <section>
        <div
          v-if="isRenew"
          :class="{ 'is-disabled': isDisabled }"
          class="renew"
        >
        <!-- TODO: 自动续费暂未接入 -->
          <!-- <span
            :class="{ renewActive: renew }"
            class="checkbox sprite-mppay"
            @click="clickRenew"
          />
          <span
            v-if="discountMoney"
          >到期自动续费<span>，立省{{ discountMoney }}元</span></span>
          <a
            target="_blank"
            href="http://www.ijinshan.com/protocol/autorenewagreement.shtml"
          >《自动续费服务协议》</a> -->
        </div>
        <div
          v-else
          class="renew"
        >
          钻石会员，不限时享受高级特权！
        </div>
      </section>
    </section>

    <div v-show="isPdfPage">
      <WeChatInterests
        :icon-list-key="['pdf']"
        title="PDF会员权益"
      />
      <WeChatInterests
        class="footer-padding"
        :icon-list-key="['duba']"
        title="PDF金山联合会员"
      />
    </div>
    <div v-show="isDubaPage">
      <WeChatInterests
        class="footer-padding"
        :icon-list-key="['pdf','duba']"
        title="PDF金山联合会员"
      />
    </div>

    <section
      v-if="!payModuleShow"
      class="pricedesc"
      @click="clickOrder"
    >
      <div class="pricedesc-btn">
        立即购买
      </div>
    </section>
  </div>
</template>

<script>
import WeChatHomeTab from '@/components/officialAccountsPay/WeChatHomeTab.vue'
import WeChatInterests from '@/components/officialAccountsPay/WeChatInterests.vue'

import { getUserInfoApi } from '@/api/user'
import { getPaySetting as getPaySettingDuba, getJsSdkConfig, getPayQrcode as getH5PayUrlDuba } from '@/api/pay.js'
import { getPaySetting as getPaySettingPdf, getPayQrcode as getH5PayUrlPdf } from '@/api/pdfPay.js'
import { loginApi } from '@/api/login'

import { wxOauth } from '@/services/pay/wxOauth'
import '@/utils/flexible'
import wx from 'weixin-js-sdk'
import Cookie from 'js-cookie'
import { precisionFloat, classes } from '@/utils/util'
import { formatDate } from '@/utils/shared.js'
import { PAGE_NUM, WXJSDK_APPID, PERMISSION_VIP_TYPE, DUBA_VIP_TYPE } from '@/config/dataMap'

const spriteCalss = classes('sprite-official-accounts-pay')
const userMarkKey = 'usermark'
const TABS_KEY_MAP = {
  pdf: 'pdf',
  duba: 'duba',
}

export default {
  name: 'MpPay',
  components: {
    WeChatHomeTab,
    WeChatInterests
  },

  data () {
    const { code, from, pdf_from, duba_from } = this.$route.query
    return {
      code,
      from,
      pdf_from,
      duba_from,
      avatar: require('@/assets/icons/official-accounts-pay/user-avatar.png'),
      curTab: 0,
      tipClass: ['', 'del'],
      settings: [],
      renewSettings: [], // 可续费套餐列表 -- 处理固定省多少钱
      isActive: 0,
      renew: true,
      userInfo: {},
      userMark: {},
      paying: false,
      render: false,
      tabs: [
        {
          text: 'PDF会员',
          icon: spriteCalss('wechat-pdf-icon'),
          active_icon: spriteCalss('wechat-pdf-icon-active'),
        },
        {
          text: '毒霸联合会员',
          icon: spriteCalss('wechat-normal-member-icon'),
          active_icon: spriteCalss('wechat-normal-member-icon-active'),
        },
      ],
      permissionVipInfo: [],
    }
  },

  computed: {
    isLogin () {
      return Object.keys(this.userInfo).length === 0
    },

    vipExDate () {
      return formatDate(this.userInfo?.vip_ex_date, 'yyyy-MM-dd')
    },

    pdfVipExDate () {
      const { vip_ex_date } = this.getPermissionVipInfoItem(PERMISSION_VIP_TYPE.member)
      return formatDate(vip_ex_date, 'yyyy-MM-dd')
    },

    // 普通会员
    isVIP () {
      return !this.isLogin && +this.userInfo?.vip_type !== DUBA_VIP_TYPE.nonmember
    },

    // 钻石会员
    isDiamondVIP () {
      return !this.isLogin && +this.userInfo?.vip_type === DUBA_VIP_TYPE.diamondMember
    },

    // 非自动续费用户
    nonContinuous () {
      return !this.isLogin && +this.userInfo?.is_continuous === 1
    },

    // 节省多少钱
    discountMoney () {
      const { renewSettings, isActive } = this
      if (!renewSettings.length) {
        return 0
      }
      const discountPrice = precisionFloat(renewSettings[isActive].price - renewSettings[isActive].current_price)
      return discountPrice > 0 ? discountPrice : 0
    },

    // 续费
    isRenew () {
      return this.settings[this.isActive]?.month_length !== 1200
    },

    // 控制自动续费多选框的隐藏
    isDisabled () {
      // 毒霸判断续费按钮是否可点   包年不可点、三年
      const disableds = {
        [TABS_KEY_MAP.pdf]: true,
        [TABS_KEY_MAP.duba]: this.settings[this.isActive]?.month_length >= 12,
      }
      return disableds[this.tabsKey]
    },

    tabsKey () {
      const keys = { 0: TABS_KEY_MAP.pdf, 1: TABS_KEY_MAP.duba }
      return keys[this.curTab] || TABS_KEY_MAP.pdf
    },

    isPdfPage () {
      return this.tabsKey === TABS_KEY_MAP.pdf
    },

    isDubaPage () {
      return this.tabsKey === TABS_KEY_MAP.duba
    },

    // pdf会员
    isPdfMember () {
      const { current_time } = this.userInfo
      const { vip_type, vip_ex_date } = this.getPermissionVipInfoItem(PERMISSION_VIP_TYPE.member)
      return +vip_type === PERMISSION_VIP_TYPE.member && vip_ex_date > current_time
    },

    // PDF终身会员
    isPdfLifeMember () {
      const { current_time } = this.userInfo
      const { vip_type, vip_ex_date } = this.getPermissionVipInfoItem(PERMISSION_VIP_TYPE.lifeMember)
      return +vip_type === PERMISSION_VIP_TYPE.lifeMember && vip_ex_date > current_time
    },

    // 支付模块是否显示
    payModuleShow () {
      if (this.isVIP) {
        return true
      }
      if (this.isPdfPage && (this.isPdfMember || this.isPdfLifeMember)) {
        return true
      }
      return false
    },

    /** 套餐show值 */
    groupShow () {
      const pdfShow = this.pdf_from && [+this.pdf_from]
      const dubaShow = this.duba_from && [+this.duba_from]

      return { [TABS_KEY_MAP.pdf]: pdfShow || [1], [TABS_KEY_MAP.duba]: dubaShow || [39] }
    }
  },

  watch: {
    renew () {
      this.getPayInfo()
    }
  },

  created () {
    this.$EventBus.$on('logout', () => {
      this.clearCookie()
      this.silentWxAuth()
    })
  },

  mounted () {
    this.init()
  },

  methods: {
    spriteCalss,
    // 静默授权
    silentWxAuth () {
      wxOauth(WXJSDK_APPID, 'snsapi_userinfo', 'silent')
    },

    async init () {
      const uk = this.getUserMark()

      if (uk) {
        this.open()
        this.userMark = uk
      }

      if (this.code) {
        this.open()
        await this.login()
      }

      if (!uk && !this.code) {
        const isPrerender = window.__PRERENDER_INJECTED__ === 'prerender'
        if (!isPrerender) {
          this.silentWxAuth()
          return
        }
        return
      }

      await this.initConfig()
    },

    async initConfig () {
      await this.getUserInfo()
      await this.initJsSdkConfig()
      if (!this.payModuleShow) {
        this.getPayInfo()
      }
    },

    // 初始化微信jssdk配置
    async initJsSdkConfig (callback) {
      try {
        const res = await getJsSdkConfig({
          ...this.commonReq(),
          url: window.location.href
        })

        wx.config({
          debug: false,
          appId: WXJSDK_APPID,
          timestamp: res.timestamp,
          nonceStr: res.nonceStr,
          signature: res.signature,
          jsApiList: ['chooseWXPay']
        })

        wx.ready(() => {
          wx.checkJsApi({
            jsApiList: ['chooseWXPay'],
            success: () => {
              callback && callback()
            },
            fail: (err) => {
              console.log('check api fail:', err)
            },
          })
        })
      } catch (e) {
        this.$toast('请在极光PDF微信公众号内打开页面')
      }
    },

    async login () {
      const res = await loginApi({
        login_type: 1, // 1 为 h5授权登录
        code: this.code, // 微信code
      })
      const result = this.dataHandle(res, true)

      if (result?.user_info) {
        this.userMark.openId = result.user_info.open_id
        this.userMark.token = result.token
        this.setUserMark(this.userMark)
      }
    },

    async getUserInfo () {
      const res = await getUserInfoApi({
        ...this.commonReq(),
        return_permission_vip: 1
      })
      const result = this.dataHandle(res, true)

      this.permissionVipInfo = result.permission_vip_info || []
      this.userInfo = result?.user_info || {}

      if (result?.user_info?.open_id !== this.userMark.openId) {
        this.clearCookie()
        this.silentWxAuth()
      }
    },

    /** 极光PDF会员与金山毒霸联合会员请求的 支付跟图标信息 接口不同 */
    async getPayInfo () {
      const paySettings = {
        [TABS_KEY_MAP.pdf]: () => getPaySettingPdf({ ...this.paySettingReq() }),
        [TABS_KEY_MAP.duba]: () => getPaySettingDuba({ ...this.paySettingReq() }),
      }
      const res = await paySettings[this.tabsKey]()
      const result = this.dataHandle(res)

      const paySetting = result.pay_price_settings || []
      this.settings = paySetting
      this.renew && (this.renewSettings = paySetting)
    },

    paySettingReq () {
      const continuou = { [TABS_KEY_MAP.pdf]: 1, [TABS_KEY_MAP.duba]: 0 }
      // TODO: 微信续费功能暂未申请
      // const is_continuous = this.renew ? 1 : 0
      const is_continuous = continuou[this.tabsKey] // 历史原因PDF用续费，毒霸联合会员不用续费
      return {
        ...this.commonReq(),
        open_id: this.userMark.openId,
        is_continuous,
        time_type: 0,
        show: this.groupShow[this.tabsKey],
      }
    },

    /** 立即购买 */
    async clickOrder () {
      if (this.paying) {
        return
      }
      this.paying = true
      try {
        const payUrls = {
          [TABS_KEY_MAP.pdf]: () => getH5PayUrlPdf({ ...this.orderReq(), uni_from: 1 }),
          [TABS_KEY_MAP.duba]: () => getH5PayUrlDuba(this.orderReq())
        }
        const res = await payUrls[this.tabsKey]()
        const result = this.dataHandle(res)

        if (result.entrust_url) {
          location.href = result.entrust_url
        } else {
          this.wechatPay(result)
        }
      } catch (e) {
        this.paying = false
        this.$toast('下单异常,请重试!')
      }
    },

    orderReq () {
      const psid = this.settings[this.isActive].id
      const show_from = parseInt(this.from)
      const commonReq = this.commonReq()
      commonReq.common.function_id = 204 // 支付上报

      return {
        ...commonReq,
        pay_setting_id: psid,
        pay_type: 'wx_web',
        pay_from: PAGE_NUM.OfficialAccounts,
        pay_channel: 1, // 1:微信,2:支付宝
        show_from: isNaN(show_from) ? 6306 : show_from,
      }
    },

    // h5调起微信支付
    wechatPay (queryObj) {
      wx.chooseWXPay({
        timestamp: queryObj.time_stamp,
        nonceStr: queryObj.nonce_str,
        package: queryObj.package,
        signType: 'MD5',
        paySign: queryObj.pay_sign,
        success: () => {
          this.paying = false
          this.$toast('支付成功!', {
            callback: () => {
              this.initConfig()
            },
          })
        },
        fail: () => {
          this.paying = false
          wx.closeWindow()
        },
        cancel: () => {
          this.paying = false
        }
      })
    },

    clickPrice (idx) {
      this.isActive = idx
    },

    clickTab (index) {
      const defaultActiveMap = { [TABS_KEY_MAP.pdf]: 0, [TABS_KEY_MAP.duba]: 1 }
      this.curTab = index
      this.isActive = defaultActiveMap[this.tabsKey] // pdf默认选中第一项 毒霸选中第二项

      if (!this.payModuleShow) {
        this.getPayInfo()
      }
    },

    clickRenew () {
      this.renew = !this.renew
    },

    open () {
      this.render = true
    },

    commonReq () {
      return {
        common: {
          open_id: this.userMark.openId,
          token: this.userMark.token,
        }
      }
    },

    dataHandle (res, needData) {
      if (res?.resp_common?.ret === 0) {
        if (needData) {
          return res.data
        }
        return res
      }
      console.error(`${res.resp_common.ret}, ${res.resp_common.msg}`)
      return false
    },

    getUserMark () {
      const um = Cookie.get(userMarkKey)
      return (um && JSON.parse(um)) || null
    },

    setUserMark (user) {
      Cookie.set(userMarkKey, JSON.stringify(user), { expires: 7 }) // 保存一个星期
    },

    clearCookie () {
      Cookie.remove(userMarkKey)
    },

    expireText () {
      if (this.isDiamondVIP) {
        return '您已升级为钻石会员，不限时享受高级特权！'
      }
      if (this.isVIP && !this.nonContinuous) {
        return `${this.vipExDate}到期`
      }
      if (this.isVIP) {
        return '您已成为会员，享受会员专属特权！'
      }
      if (this.isPdfMember) {
        return `PDF会员${this.pdfVipExDate}到期`
      }
      if (this.isPdfLifeMember) {
        return 'PDF会员  终身有效'
      }
      return '升级为会员，享受高级特权'
    },

    getPermissionVipInfoItem (vip_type) {
      return this.permissionVipInfo.find((item) => +item.vip_type === vip_type) || {}
    }
  },
}
</script>

<style  lang="scss">
@import '~@/assets/css/sprite-official-accounts-pay.scss';
html,
body {
  user-select: none;
  overflow-y: inherit;
}
::-webkit-scrollbar {
  display: none;
}
::-webkit-scrollbar-thumb {
  background-color: transparent;
}
.mppay-wrap {
  width: 750px;
  margin: 0 auto;
  background: #f0f0f0;
  .userinfo {
    display: flex;
    justify-content: center;
    background: #3c3d4b;
    padding: 40px;
    .top-banner {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .icon-avatar {
        border-radius: 50%;
      }
      img {
        width: 80px;
        height: 80px;
        margin: 0 16px 0 30px;
      }

      dl,
      dt,
      dd {
        display: flex;
      }

      dd {
        flex-direction: column;
        color: #732d0a;
      }

      .nickname {
        font-size: 28px;
        margin-bottom: 10px;
        font-weight: 500;
        color: #333333;
      }

      .expire {
        font-size: 24px;
        font-weight: 400;
        color: #978c0f;
      }
      .pdf-name {
        font-size: 40px;
        color: #a63227;
        font-weight: 400;
        margin-left: 30px;
        margin-bottom: 15px;
      }
      .introduction {
        margin-left: 30px;
        font-size: 24px;
        font-weight: 400;
        color: #e65648;
      }
    }
  }
  .package-container {
    height: 320px;
    overflow: hidden;
    background: #fff;
    margin-bottom: 20px;
    .timeopts-overflow {
      display: flex;
      padding-left: 40px;
      padding-top: 20px;
      overflow: hidden;
      overflow-x: scroll;
      .timeopts-li,
      .timeopts-ul {
        display: flex;
      }
      .timeopts-ul {
        list-style: none;
        .timeopts-li {
          flex-shrink: 0;
          border-radius: 10px;
          margin-right: 30px;
          width: 203px;
          height: 230px;
          box-sizing: border-box;
          flex-direction: column;
          text-align: center;
          background: #f0f0f0;
          align-items: center;
          .timeopts-litips {
            font-size: 28px;
            font-weight: 500;
            color: #333333;
            height: 60px;
            line-height: 60px;
          }
          .timeopts-content {
            height: 167px;
            width: 199px;
            background: #fff;
            border-radius: 0 0 5px 5px;
            .price {
              font-size: 60px;
              font-weight: 600;
              color: #a63227;
              margin: 20px 0;
              &:first-letter {
                font-size: 24px;
              }
            }
            .tip {
              font-size: 24px;
              font-weight: 500;
              color: #e65648;
            }
          }

          &.active {
            background: #ebd252;
            .timeopts-content {
              background: #fffad9;
            }
          }
        }
      }
    }

    .renew {
      padding: 20px 0 25px 30px;
      font-size: 24px;
      color: #7a7a7a;
      a {
        color: #b07400;
      }
    }
    .is-disabled {
      visibility: hidden;
    }
    .checkbox {
      // @extend .sprite-mppay-ckb2;
      width: 28px;
      margin-right: 10px;
      position: relative;
      top: -2px;
      &.renewActive {
        // @extend .sprite-mppay-ckb1;
      }
    }
  }
  .pricedesc {
    margin: 0 auto;
    position: fixed;
    bottom: 12px;
    left: 0;
    right: 0;
    width: 600px;
    height: 90px;
    background: linear-gradient(180deg, #e8d674, #fff7c6);
    border-radius: 45px;
    font-size: 32px;
    font-weight: 500;
    color: #333333;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
 .footer-padding{
    padding-bottom: 100px;
  }
}
</style>
